module.exports = __webpack_public_path__ + "static/le-personnel-a6e601bfb8e2cefefbe1571bcdd8d66c.jpg";